import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { SETable } from "../../../../components/SETable";
import { RiFilterOffLine } from "react-icons/ri";
import { SEText } from "../../../../components/SEText";
import useFilterHandler from "../../../../hooks/useFilterHandler";
import { useQuery } from "react-query";
import { tableColumns } from "./tableColumns";
import { ErrosEnvioSasService } from "../services";
import { SEButton } from "../../../../components/SEButton";
import useAbortableRequest from "../../../../../hooks/useAbortableRequest";
import { SEButtonExport } from "../../../../components/SEButtonExport";
import { formatDateToBR } from "../../../../../utils/time";
import useExcelExport from "../../../../hooks/useExcelExport";
import { removeEmptyProperties } from "../../../../utils/utils";
import SEInputSearch from "../../../../components/SEInputSearch";

const Tabela = () => {
  const [searchText, setSearchText] = useState<any>(null);

  const { createAbortController, cancelRequests } = useAbortableRequest();

  const {
    paginationFilters,
    bodyFilters,
    handleResetBodyFilters,
    handleLinesPerPage,
    handleChangeOrder,
    handlePageChange,
    handleSearchChange,
  } = useFilterHandler();


  const handleClickApplyFilter = async (inputValue: any, oqueVocePrecisa: boolean = false) => {
    setSearchText(inputValue);
    handleSearchChange(inputValue, oqueVocePrecisa)
  }

  const handleCleanFilters = () => {
    handleResetBodyFilters();
    setSearchText(null);
  };

  const { data, isLoading } = useQuery({
    queryFn: () =>
      ErrosEnvioSasService.findAll(
        paginationFilters,
        bodyFilters,
        createAbortController()
      ),
    queryKey: ["errosEnvioSASFindAll", paginationFilters, bodyFilters],
  });
  console.log(`isLoading`, isLoading);

  useEffect(() => {
    return () => {
      cancelRequests();
    };
    // eslint-disable-next-line
  }, []);

  const fetchDataExcel = async () => {
    const bodyParams = removeEmptyProperties(bodyFilters);
    const pageFilter = { ...paginationFilters, page: 0, linesPerPage: 1000 };

    const response = await ErrosEnvioSasService.findAll(pageFilter, bodyParams);

    return response?.content?.map((r: any) => ({
      DESCRICAO: r.descricao,
      QUANTIDADE: r.total,
    }));
  };

  const { executeDownload, downloading } = useExcelExport({
    handleDataCallback: fetchDataExcel,
    filename: `Erros_Envio_SAS_${formatDateToBR(new Date())}`,
    colorLoading: "#3498db",
    isCsv: false,
  });

  return (
    <Grid item>
      <Grid container>
        <Grid item xs={12}>
          <SETable
            pagination={true}
            headerTableColor={"#7B80FF"}
            tableColor={"#FFFFFF"}
            totalElements={data?.totalElements}
            totalPages={data?.totalPages}
            linesPerPageFilters={paginationFilters?.linesPerPage}
            isLoading={isLoading}
            data={data?.content ?? []}
            page={paginationFilters?.page}
            columns={tableColumns()}
            orderBy={paginationFilters?.orderBy}
            direction={paginationFilters?.direction}
            onOrderChange={handleChangeOrder}
            onPagePreviousChange={handlePageChange}
            onPageNextChange={handlePageChange}
            onLinesPerPageChange={handleLinesPerPage}
            tableHeader={
              <>
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                  mb={2}
                >
                  <Grid item md={3}>
                    <SEInputSearch
                        value={searchText}
                        onClick={(inputValue) => handleClickApplyFilter(inputValue, false)}
                    />
                  </Grid>

                  <Grid item>
                    <div
                      style={{
                        display: "flex",
                        marginTop: "16px",
                        alignItems: "center",
                      }}
                    >
                      <SEButton onClick={handleCleanFilters}>
                        <RiFilterOffLine size={20} /> Limpar Filtros
                      </SEButton>
                    </div>
                  </Grid>
                </Grid>

                <Grid
                  container
                  justifyContent="flex-end"
                  alignItems="center"
                  mb={2}
                  sx={{ padding: "7px" }}
                >
                  <Grid item>
                    <div
                      style={{
                        display: "flex",
                        marginTop: "16px",
                        alignItems: "center",
                      }}
                    >
                      {!!data?.totalElements && (
                        <SEText as="p" font="Mulish">
                          <strong>{data?.totalElements}</strong>{" "}
                          {data?.totalElements === 1
                            ? "resultado encontrado"
                            : "resultados encontrados"}
                        </SEText>
                      )}
                    </div>
                  </Grid>
                  <Grid item>
                    <SEButtonExport
                      isLoading={downloading}
                      onClick={executeDownload}
                    />
                  </Grid>
                </Grid>
              </>
            }
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Tabela;
